import Marquee from "../ui/Marquee";
import ScrollReveal from "../motion/ScrollReveal";
import StaggerContainer from "../motion/StaggerContainer";
import TiltCard from "../motion/TiltCard";

const industries = [
  {
    name: "Legal & Law Firms",
    tagline: "From case management to courtroom visibility",
    services: ["Law Firm CRM", "OWL CaseMind AI", "Legal PR"],
    href: "/industries/legal",
  },
  {
    name: "Real Estate",
    tagline: "Build pipeline, manage properties, close deals",
    services: ["Real Estate CRM", "AI Lead Follow-up", "Property Portals"],
    href: "/industries/real-estate",
  },
  {
    name: "Healthcare",
    tagline: "Patient systems as reliable as your practice",
    services: ["Hospital Management", "AI Appointment Bot", "Patient CRM"],
    href: "/industries/healthcare",
  },
  {
    name: "Education",
    tagline: "From admissions to alumni, end-to-end",
    services: ["EdTech Platforms", "Admissions CRM", "Student Portals"],
    href: "/industries/education",
  },
  {
    name: "Manufacturing",
    tagline: "Operations ERP for shop floor and boardroom",
    services: ["Manufacturing ERP", "Inventory Control", "Supply Chain AI"],
    href: "/industries/manufacturing",
  },
  {
    name: "E-Commerce & Retail",
    tagline: "D2C brands that convert, retain, and scale",
    services: ["Shopify/Custom Store", "AI Recommendations", "D2C Marketing"],
    href: "/work",
  },
];

const marqueeItems = [
  "LEGAL & LAW FIRMS",
  "REAL ESTATE",
  "HEALTHCARE",
  "EDUCATION",
  "RETAIL & E-COMMERCE",
  "MANUFACTURING",
  "FINANCE & BANKING",
  "LOGISTICS",
  "HOSPITALITY",
  "IT & SAAS",
];

export default function IndustriesSection() {
  return (
    <>
      <section style={{ background: "#050505", padding: "100px 0" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto 48px", padding: "0 40px" }}>
          <ScrollReveal direction="up">
            <div
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 300,
                fontSize: "clamp(36px, 4.5vw, 56px)",
                color: "#F8F4EC",
                lineHeight: 0.95,
              }}
            >
              We speak
            </div>
            <div
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: "clamp(36px, 4.5vw, 56px)",
                color: "#D4A843",
                lineHeight: 1,
                marginBottom: 40,
              }}
            >
              your industry.
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal direction="none" delay={0.1}>
          <div style={{ marginBottom: 48 }}>
            <Marquee items={marqueeItems} direction="left" speed={60} size="lg" />
          </div>
        </ScrollReveal>

        <StaggerContainer
          stagger={0.08}
          className="owl-industries-grid"
          style={{ maxWidth: 1280, margin: "0 auto", padding: "0 40px", display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 1 }}
        >
          {industries.map((industry) => (
            <a
              key={industry.name}
              href={industry.href}
              style={{ textDecoration: "none", display: "block" }}
            >
              <TiltCard
                style={{
                  background: "#0E0E0E",
                  border: "1px solid rgba(212,168,67,0.18)",
                  borderRadius: 3,
                  padding: 28,
                  height: "100%",
                }}
              >
                <div
                  className="ind-name"
                  style={{
                    fontFamily: "'Playfair Display', serif",
                    fontWeight: 300,
                    fontSize: 24,
                    color: "#F8F4EC",
                    marginBottom: 10,
                    transition: "color 0.3s ease",
                  }}
                >
                  {industry.name}
                </div>
                <div
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontWeight: 300,
                    fontSize: 15,
                    color: "#8B8378",
                    marginBottom: 20,
                    lineHeight: 1.6,
                  }}
                >
                  {industry.tagline}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {industry.services.map((service) => (
                    <div
                      key={service}
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: 300,
                        fontSize: 14,
                        color: "#908A83",
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <span style={{ color: "#D4A843", opacity: 0.8 }}>—</span>
                      {service}
                    </div>
                  ))}
                </div>
              </TiltCard>
            </a>
          ))}
        </StaggerContainer>
      </section>

      <style>{`
        @media (max-width: 960px) {
          .owl-industries-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          }
        }

        @media (max-width: 640px) {
          .owl-industries-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </>
  );
}
